import { isNil } from 'lodash'

import { createMemberRoleApi } from '@eastcoal/api/auth/memberRole/createMemberRole'
import { updateMemberRoleApi } from '@eastcoal/api/auth/memberRole/updateMemberRole'
import { queryRoleApi } from '@eastcoal/api/auth/role/queryRole'

import { PageContainer } from '@eastcoal/common/components/Layout/PageContainer'
import { omit } from '@eastcoal/common/utils/object'

import { CrudForm } from '@eastcoal/formily/components/CrudForm'
import { BackButton } from '@eastcoal/formily/components/CrudForm/shared/BackButton'
import { SubmitButton } from '@eastcoal/formily/components/CrudForm/shared/SubmitButton'
import { FormItem } from '@eastcoal/formily/components/FormItem'
import { Input } from '@eastcoal/formily/components/Input'
import { TextArea } from '@eastcoal/formily/components/TextArea'

import { useAuthStore } from '@eastcoal/auth/hooks/useStore'
import { useNavigate } from '@eastcoal/router/exports/react-router'
import { ResourceTree } from '@eastcoal/shared/@formily/ResourceTree'

import { RoleFormPrivateProps, RoleFromProps } from './interface'

const items: RoleFormPrivateProps['schema'] = [
  {
    name: 'name',
    title: '角色名称',
    type: 'string',
    required: true,
    'x-component': Input,
    'x-decorator': FormItem
  },
  {
    name: 'description',
    title: '描述信息',
    type: 'string',
    'x-component': TextArea,
    'x-decorator': FormItem
  },
  {
    name: 'resources',
    title: '资源权限',
    type: 'array',
    'x-component': ResourceTree,
    'x-decorator': FormItem
  }
]

const layout: RoleFormPrivateProps['layout'] = {
  wrapperWidth: 320
}

const readApi: RoleFormPrivateProps['readApi'] = ({ id }) => {
  return {
    api: () => queryRoleApi({ id }).then(data => omit(data, ['memberId'])),
    ready: !isNil(id)
  }
}

export const RoleForm = ({ mode }: RoleFromProps) => {
  const member = useAuthStore(state => state.member)

  const navigate = useNavigate()
  return (
    <PageContainer>
      <CrudForm
        createApi={createMemberRoleApi}
        layout={layout}
        mode={mode}
        name='roleForm'
        readApi={readApi}
        schema={items}
        updateApi={updateMemberRoleApi}
        actions={[
          <BackButton key='backButton' />,
          <SubmitButton key='submitButton' />
        ]}
        values={{
          memberId: member.id
        }}
        onSuccess={() => navigate(-1)}
      />
    </PageContainer>
  )
}
